/* @flow */
// first because it patches runtime env
import 'polyfill';
import 'utils/setupErrorLogging';
import 'lib/apolloErrorListener';

import invariant from 'invariant';
import * as React from 'react';
import ReactDOM from 'react-dom';
import Config from 'Config';
import { AppContainer } from 'react-hot-loader';
import Modal from 'react-modal';

import { createReduxStore } from 'reduxStore';
import AppActions from 'actions/AppActions';
import AuthActions from 'auth/AuthActions';
import { registerInterceptor } from 'singletons/xhrInterceptors';
import { serviceUnavailableInterceptor } from 'lib/ResponseInterceptors';
import { getApolloClientSingleton } from 'lib/apollo/client/browser';
import { initDatadog } from 'lib/datadog';

import Error from 'main/Error';
import Root from 'main/Root';

import './styles/app.scss';

__webpack_public_path__ = Config.Environment.PUBLIC_PATH; // eslint-disable-line

registerInterceptor('503-interceptor', serviceUnavailableInterceptor);

console.debug('Initial Referrer: ', document.referrer);

const reduxStore = createReduxStore();

initDatadog();

function renderApp() {
  AppActions.observeConnection();

  // this enable modal accesibility
  // by preventing screen reader from reading
  // what is inside #app when a modal is openend.
  Modal.setAppElement('#app');
  Modal.defaultStyles = {};

  const container = document.getElementById('app');
  invariant(container, 'renderApp missing app container');

  try {
    ReactDOM.render(
      <AppContainer>
        <Root reduxStore={reduxStore} apolloClient={getApolloClientSingleton()} />
      </AppContainer>,
      container
    );
  } catch (e) {
    console.debug(e, e && e.stack);
    console.error('fatal app error on render');
    ReactDOM.render(<Error />, container);
  }
  // $FlowFixMe Flow doesn't know about `module.hot`
  if (module.hot) {
    // $FlowFixMe Flow doesn't know about `module.hot`
    module.hot.accept('main/Root', () => {
      const NextRoot = require('main/Root').default;
      ReactDOM.render(
        <AppContainer>
          <NextRoot reduxStore={reduxStore} apolloClient={getApolloClientSingleton()} />
        </AppContainer>,
        container
      );
    });
  }
}
// The app should load whether or not there are issues fetching user data.
AuthActions.loadAppDataIfWindowUser().then(renderApp, renderApp);
